import React, { useState, useEffect } from 'react';
import style from './QuizOne.module.sass';
import globeMap from '../media/globeMap.svg';
import { Transition, CSSTransition } from 'react-transition-group';


const myQuestions = [
    {
        question: "Which of below practices do you think is true?",
        answers:[
            "In Japan, men refrain from swimming if they are grumpy.",
            "In India, menstruating women are not allowed to enter temples.",
            "In South Africa, children are forbidden from drinking water in amusement parks."
        ],
        correctAnswer: 1,
        explanation: "Religion plays a vital part in forming the stigmatisation of period. In some Hindu temples, women of menstruating age are banned altogether. The lift of the ban in 2018 on one of India’s holiest temples, led to violent protests accusing politicians trying to “destroy their culture and religion”. Sadly, both men and women were among the protestors.",
    },
    {
        question: "Jewish law forbids sexual relations while a woman is a Niddah, which means:",
        answers:[
            "She is menstruating.",
            "She just had hot yoga class and would not like to have sex right away.",
            "She is hungry."
        ],
        correctAnswer: 0,
        explanation: "Not only sexual relations, a Niddah is also forbidden from touching, sometimes even passing objects, to her husband, under such “family purity” laws of Judaism. She then has to emerge from a mikveh, or a Jewish ritual bath, with regained purity, whatever that might mean.",
    },
    {
        question: "In Italy, it is believed doughs won't rise because:",
        answers:[
             "The cook is on her period.",
             "It's too dark in the kitchen.",
             "The weather is bad."
        ],
        correctAnswer: 0,
        explanation: "While many such nonsensical myths have long been taken down from the shelf worthy of serious consideration, the invisible roots of the implied casual sexism still seem to linger, even in modern-day UK, where almost half of young girls are embarrassed by their periods.",

    },
    {
        question: "Which of below only has 2% usage in China?",
        answers:[
             "Tampons, as it might break the hymen.",
             "Knives for cooking, as it might render vegetables impure thus poisonous",
             "Mirrors, as it might summon the demon.",
        ],
        correctAnswer: 0,
        explanation: "Perhaps due to the lack of discussion and the absurd association between a woman’s value and her “purity”, the majority of Chinese women still rely on a “vagina mattress” for the bleeding days, with many even unaware of any other option.",

    },
    {
        question: "Which of below did not happen in 2019?",
        answers:[
             "A Nepali teen died on her period after being banished to a hut.",
             "A Kenyan girl took her own life after “period shaming”.",
             "The normalisation and open discussion around period.",
        ],
        correctAnswer: 2,
        explanation: "Talking is the starting point of ending stigma. Tell someone you’re menstruating, today, proudly.",
    },
]

//Overall top component (return Slides and Intro components) 
const QuizOne = (props) => {
    // const [showIntro, setShowIntro] = useState(true)
    const showIntro = true
    const [showQuiz, setShowQuiz] = useState(false)

    const changeView = () => {
        setShowQuiz(!showQuiz)
        props.playPaperFlip()
    }
    return (
        <>
            {showIntro && (
                <QuizOneIntro handleClick={changeView} />
            )
            }
            <CSSTransition
            in = {showQuiz}
            timeout = {300}
            classNames = "quizSlidesAni"
            unmountOnExit
            >  
                <QuizOneSlides 
                handleClick={changeView}
                playPaperFlip = {props.playPaperFlip} 
                playCorrect = {props.playCorrect} 
                playSwitch = {props.playSwitch}  
                />
            </CSSTransition>
            
        </>
    )
}

//Intro (handleClick)
const QuizOneIntro = (props) => {
   
    return (
        <>
            <div className={`${style.enterQuiz} main`}>
                <div className = {`${style.enterQuizTitle} titleOneText`}>
                    <div className = {style.weak}> Period Taboos 
                        <span>
                            <svg className = {`${style.globeIcon} globeIcon`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121 121">
                                <path d="M66.268,41.2c-.176-.333,1.724-.514,2.062-.514C68.7,40.727,67.342,42.96,66.268,41.2ZM55.418,25.707l.545-.156c.323.277-.363.479-.257.686a1.95,1.95,0,0,1,.04,1.674c-.071.429-.524.242-.751.469-.267.333,1.3.378,1.321.429.055.166-1.891.449-1.533.862.484.686,4.154-.983,3.569-.887,1.134-.57.146-.63-.489-.958-.217-1.084-.4-2.758-1.074-3.428l.444-.514c-1.039-1.507-1.815,1.825-1.815,1.825ZM121,60.5A60.5,60.5,0,1,1,60.5,0,60.5,60.5,0,0,1,121,60.5ZM79.1,33.421c-.03-.736-.958-1.432-1.926-.156-.681.877-.56,2.213-.928,2.808-.524.882,2.859,1.709,2.859.877.126-1.4,3.69-.318,4.386-.126,1.25.348,3.242-1.139,1.064-1.921-1.79-.655-2.733-1.356-2.894-2.637,0,0,.948-.887.534-.837-1.1.136-3.1,3.963-3.1,1.991ZM110.846,60.5a48.168,48.168,0,0,0-1.8-13.27,3.083,3.083,0,0,0-1.81-1.906c-1.291-.5-6.741,3.01-7.563,1.281-.539-1.155-1.634.736-2.884.04-.605-.333-2.289-2.6-3.05-2.319-1.558.56,2.39,4.86,3.469,5.425,1.013-.766,4.3-2.344,5-.192,1.351,4.053-3.716,8.5-6.307,10.835-3.872,3.5-3.146-2.264-5.783-4.3-1.386-1.064-1.371-3.327-2.773-4.109-.625-.353-3.494-3.655-3.469-4.1l-.086.837c-.474.358-1.482-1.351-1.588-1.618,0,1.487,2.42,3.857,3.222,5.047,1.366,2.042,2.1,5.016,3.771,6.685.9.9,4.326,4.608,5.218,4.527.973-.086,4.048-2.309,4.593-2.183,3.247.766-7.643,16.159-8.677,18.064-.852,1.6.7,5.551.57,7.442-.146,2.183-1.865,2.889-3.494,4.079-1.744,1.276-1.336,3.756-2.8,4.664-2.607,1.6-4.482,6.821-8.183,6.8-1.089-.005-5.748,1.815-6.358.035a28.754,28.754,0,0,0-1.78-3.544c-.655-1.25-.076-2.546-.872-3.65-.55-.766-2.395-2.506-2.561-3.413-.01-.781.59-3.156,1.412-3.569,1.155-.59.222-2.309.081-3.307a6.711,6.711,0,0,0-2.672-4.29c-1.961-1.507-.948-2.707-.489-4.86,0-1.028-.625-2.38-2.007-1.976-2.844.827-1.981-2.218-4.054-2.082-1.492.106-2.712,1.054-4.1,1.472-1.744.524-3.529-.413-5.253-.63-7.094-.9-9.408-9-7.557-14.853.187-.958-.575-2.733-.242-3.474a18.143,18.143,0,0,1,3.842-5.112c.8-.756,1.82-.565,2.758-1.155,1.447-.913,1.467-2.788,2.884-3.938,2.017-1.639,4.769-1.6,7.4-1.956,1.4-.187,6.736-1.341,7.578-.3,0,.192.963,3.045-.1,2.884,2.183.116,5.294,3.776,7.366,2.919,1.064-.444.676-3.711,2.859-2.133,1.321.948,7.24,1.371,8.47.348.756-.625,1.18-4.689.262-5.148.585.58-3.08.625-3.423.494-.605-.222-1.17.575-2.143.126.585.277-3.257-1.785-1.1-3.363-.9.66-1.744-.187-2.717.539-.671.545.313.908-.645,1.381-1.523.771-2.672-2.647-3.247-3.035s-5.112-3.559-3.882-1.487l3.978,3.958c-.2.126-1.044-1.442-1.044-.3.267-.681.1,2.919-.524,1.749-.277-.449.454-.7.03-1.351,0-.429-1.15-.847-1.371-1.139a13.768,13.768,0,0,0-3.212-2.919,26.269,26.269,0,0,0-4.154.555,8.969,8.969,0,0,0-.9,1.568,10.18,10.18,0,0,0-2.112,1.079l-.792,1.78c-.343.308-3.857,1.467-3.877,1.512.146-.378-2.455-.862-2.284-1.618.192-.832,1.074-3.428.847-4.376-.242-.993,5.415,1.432,5.778-1.185.146-1.134.232-2.455-1.578-2.647A13.407,13.407,0,0,0,58.947,30c.736-.847,2.425-2.228,3.65-2.228,1.432,0,1.124-2.082,1.785-3.1.66.267-.353,1.9.439,2.556-.05-.519,2.244.287,2.465.166.524-.272,3.448-.111,2.995-1.482-.5-1.4.257-.983.913-1.276-.111.045,1.714-3.121,2.027-2.082-.217-1.069-2.123.373-2.788.318-1.538-.121-.887-2.622-.308-3.353.449-.58-1.225-1.291-1.245-.181C68.849,21,67.306,22.5,67.664,24.7c.544,3.322-3.706-.8-4.079-.575-1.412.857-2.566-1.079-1.835-2.239.746-1.185,2.546-1.129,3.287-2.4a10.032,10.032,0,0,1,1.941-2.622c2.7-2.264,3.443-.454,6.131-.207,2.627.242.887.625.524,1.634-.348.958,1.442,1.3,2.062.5A13.363,13.363,0,0,0,77.2,16.3c.449-1.119,4.543-.993,1.684-2.7-1.886-1.124-10.1-3.388-15.609-3.388-1.19,0-2.022,1.326-2.929,2.077-1.795,1.487-6.393,4.406-8.949,3.519-2.617-.9-8.218,3.327-9.115,3.358-.328.02.02-3.2,1.8-3.433-.771.116,6.287-3.564,6.1-4.331-.232-.907-14.112,4.144-13.492,5.158.3.464,1.507.464-.081,1.482-.907.55-1.875,4.038-2.728,4.038-2.546,1.114-2.707-2.193-5.541,2.062L23.832,25.96A50.212,50.212,0,0,0,10.824,52.091c-.066.4,1.684,1.139,1.911,1.412.565.676.565,3.59.842,4.543.7,2.41,2.415,3.751,3.731,5.944.776,1.306,2.067,4.608,1.659,5.979.544-.9,5.395,4.109,6.282,5.153,2.087,2.455,3.7,5.43.308,7.86-1.094.787,1.664,5.692.242,6.9l-1.82.469c-1.795,1.1-.983,3.812.106,4.951a50.358,50.358,0,0,0,86.762-34.8ZM52.832,28.45c.63-.277,1.477-.267,1.568-1.109.076-.746.222-.232.4-.5s-.338-.7-.555-.736c-.323-.071-.544.348-.751.524l-.363.1-.343.439.04.242-.439.534c-.429.424.01.7.439.514Z"/>
                            </svg>
                        </span> 
                    </div>
                    <div className = {style.strong}>around the globe</div>
                </div>

                <div className = {style.enterQuizButtonContainer}>
                <div className = {`${style.enterQuizButton} buttonOne`} onClick={props.handleClick}>Enter Quiz</div>
                </div>
            </div>

            <div className={`${style.exampleQuiz} exampleQuizColor`}>

                <div className = {style.exampleChoice}>
                    <h2>95<span>%</span></h2>
                    <h2>99<span>%</span></h2>
                    <h2 className = {`${style.exampleCorrect} exampleCorrectColor`}>55<span>%</span></h2>
                </div>

                <div className = {style.exampleQuestion}>
                    <h3> teenage girls in India think of menstruation as a natural process.</h3>
                </div>
                
            </div>
        </>
    )
}

//Slides
const QuizOneSlides = (props) => {
         
    const numOfQuestions = myQuestions.length

    // Get toggleSlide function to changes targetStamp number
    let [targetStamp, setTargetStamp] = useState(0)

    // Timeline loops
    const toggleSlide = (direction) => {
        props.playPaperFlip()
        if (direction === 'next' && targetStamp < numOfQuestions - 1) {
            setPrevAni(false)
            setInProp(false)
            setTimeout(() => {
                setTargetStamp(targetStamp + 1)
                setInProp(true)
            }, duration);
        } else if (direction === 'next' && targetStamp >= numOfQuestions - 1) {
            setPrevAni(false)
            setInProp(false)
            setTimeout(() => {
                setTargetStamp(0)
                setInProp(true)
            }, duration);
        } else if (direction === 'prev' && targetStamp > 0) {
            setPrevAni(true)
            setInProp(false)
            setTimeout(() => {
                setTargetStamp(targetStamp - 1)
                setInProp(true)
            }, duration);
        } else if (targetStamp <= 0) {
            setPrevAni(true)
            setInProp(false)
            setTimeout(() => {
                setTargetStamp(numOfQuestions - 1)
                setInProp(true)
            }, duration);
        }
    }

    const [inProp, setInProp] = useState(true);
    const [prevAni, setPrevAni] = useState(false);
    const duration = 300;

    const defaultStyle = {
    transition: `transform ${duration}ms ease`,
    transform: 'translateX(0)',
    }

   let transitionStyles 

    if (prevAni) {
        transitionStyles = {
            entering: { transform: 'translateX(-90%)', opacity: '0',},
            entered:  {  transform: 'translateX(0)'},
            exiting:  {  transform: 'translateX(0)'},
            exited:  {  transform: 'translateX(40%)'},
        }} else {
            transitionStyles = {
            entering: { transform: 'translateX(40%)', opacity: '0',},
            entered:  {  transform: 'translateX(0)'},
            exiting:  {  transform: 'translateX(0)'},
            exited:  {  transform: 'translateX(-100%)'},
            }
        }

    return (

        <div className={`${style.quizSlides} main`}>
         
            {/* Question content, quizSlide */}
            <div className = {style.quizSlide}>
                <div className = {style.globeMapContainer}>
                    <img alt = "Global Map" className = {style.globeMap} src = {globeMap}></img>
                </div>
                <button className = {`${style.backButton} backButton`} onClick={props.handleClick}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 83.523 89.418">
                    <g id="Polygon_3" data-name="Polygon 3" transform="matrix(0.017, -1, 1, 0.017, 0, 87.987)">
                        <path d="M 87.16427612304688 81.5 L 0.8357251882553101 81.5 L 44 1.057487845420837 L 87.16427612304688 81.5 Z" stroke="none"/>
                        <path d="M 44 2.114997863769531 L 1.671463012695312 81 L 86.32853698730469 81 L 44 2.114997863769531 M 44 0 L 88 82 L 0 82 L 44 0 Z" stroke="none"/>
                    </g>
                    </svg>
                </button>
                <Transition in={inProp} exit = {false} timeout={duration}>
                    {state => (
                        <div style={{
                            ...defaultStyle,
                            ...transitionStyles[state]
                          }}>
                         <Question 
                            playCorrect = {props.playCorrect} 
                            playSwitch = {props.playSwitch} 
                            question={myQuestions[targetStamp].question} 
                            answers= {myQuestions[targetStamp].answers} 
                            correctAnswer={myQuestions[targetStamp].correctAnswer} 
                            explanation={myQuestions[targetStamp].explanation}/> 
                        </div>
                    )}
                </Transition>
        
            </div>

            {/* Timeline */}
            <div className={style.timelineContainer}>

                {/* Stamps */}
                <div className={style.timelineStamps}>
                    <div className={style.dashedLine}></div>
                    {
                        myQuestions.map((stamp, i) => {
                            return (
                                <div key = {i} onClick = {() => setTargetStamp(i)} className={`${style.stamp} ${i === targetStamp && `stampChecked`} main stamp`}></div>
                            )
                        })
                    }
                </div>

                {/* Buttons */}
                <div className={style.timelineButtons}>
                    <div className={`${style.prevButton} titleTwo timelineButton`} onClick={() => toggleSlide('prev')}>{`<`}</div>
                    <div className={`${style.nextButton} titleTwo timelineButton`} onClick={() => toggleSlide('next')}>{`>`}</div>
                </div>
            </div>
        </div>
    )
}

//Quiz on slide
const Question = (props) => {

    // initial inefficient way of playing sound
    // const correctSound = React.createRef()
    // const incorrectSound = React.createRef()
    
    // const playCorrectSound = () => {
    //     correctSound.current.volume = 0.4;
    //     correctSound.current.play();
    // }

    // const playIncorrectSound = () => {
    //     incorrectSound.current.volume = 0.4;
    //     incorrectSound.current.play();
    // }
    const [answers, setAnswers] = useState()
    const [clicked, setClicked] = useState (false)

    //updates when props change, "props.answers" is now "answers" with "answer" objects
    useEffect(() => {

        let data = props.answers.map((answer, i) => {
            return {
                answerText: answer, 
                isCorrect: i === props.correctAnswer,
            }
        })
        setAnswers(data)
        setClicked(false)
    }, [props])
    
   //add style depending on user answer
    const tellAnswer = (i) => {

    setClicked(true)

    const selector =  document.querySelector(`#label${i}`)
    const greenAnswer = document.querySelector(`#label${props.correctAnswer}`)
    const explanation = document.querySelector("#explain")

       if(answers[i].isCorrect){
            selector.classList.add(`${"correct"}`)
            explanation.classList.add(`${style.visible}`)
            props.playCorrect()

       } else {
           selector.classList.add(`${"wrong"}`)
           greenAnswer.classList.add(`${"correct"}`)  
           explanation.classList.add(`${style.visible}`)
           props.playSwitch()
        }
   }

    return (
        <div key={props.question} className = {style.quizContentContainer}>
            {/* <audio src = {correct}  className = {style.audioFile} ref = {correctSound} ></audio>
            <audio src = {incorrect}  className = {style.audioFile} ref = {incorrectSound} ></audio> */}
            {/* Explanation */}
            <div className = {style.explanationContainer}>
                <h1 id = "explain" className={`${style.explanation} explanation`}>{props.explanation}</h1>
            </div>
            
            {/* Quizzis */}
            <div className = {style.mainQuizContainer}>
                <h1 className={`${style.question} titleOneText`}>{props.question}</h1> 
                <ul className={style.answers}>    
                {answers && answers.map((answer, i) => {
                    return(
                            <li key={i}>
                                <input id={`radio${i}`} type="radio" name={`quizOneAnswer`} />
                                <label 
                                    className = "paraOneText"
                                    id={`label${i}`}
                                    onClick={!clicked ? () => tellAnswer(i) : null} 
                                    htmlFor={`radio${i}`}
                                >
                                    {answer.answerText}
                                </label>
                            </li>
                        )
                    })}
                </ul>
            </div>

        </div>
             
    )
}

export default QuizOne

//initial inefficient way of listing quiz answers

  /* {props.answers.map((answer, i) => {
        //         return(
        //             <li key={i}>
        //                 <input id={`radio${i}`} type="radio" name={`answer`} />
        //                 <label onClick={() => tellAnswer(i)} htmlFor={`radio${i}`}>
        //                     {answer}
        //                 </label>
        //             </li>

        //             )
        //     })
        //    } */

        //     {/* <li>
        //     <input id="radio1" type="radio" name="answer"/>
        //     <label for="radio1">
        //     {props.answers[0]}
        //     </label>
        //     </li>

        //     <li>
        //     <input id="radio2" type="radio" name="answer"/>
        //     <label for="radio2">
        //     {props.answers[1]}
        //     </label>
        //     </li>

        //     <li>
        //     <input id="radio3" type="radio" name="answer"/>
        //     <label for="radio3">
        //     {props.answers[2]}
        //     </label>
        //     </li> */}
 

        //     {/* <ul>

        //     {
        //     props.answers.map((answer, i) => {
        //             return (
        //             <li className={style.inputGroup}>
        //                 <input id="radio1" type="radio" name="answer"/>
        //                 <label for="radio1">
        //                 {answer}
        //                  {i === props.correctAnswer && 'Correct Answer'}
        //                 </label>
        //             </li>

        //             )
        //         })
        //     }
        //     </ul> */}
